import * as React from 'react';
import { AutoSizer, List, ListRowProps, Size } from 'react-virtualized';

import { IFRFriend } from '../fr-friend-list-common';
import { FRFriendListItem } from '../fr-friend-list-item';
import './fr-friend-list-virtualized.styles.less';
import { getModeClass } from 'utils/css';

export class FRFriendListVirtualized extends React.Component<IFRFriendListVirtualizedProps> {
    /* These values are provided in stylesheet - container should replace certain elements with given height */
    public readonly ROW_HEIGHT: number = 95;
    public readonly CONTAINER_HEIGHT: number = this.ROW_HEIGHT * 3 + 24 + 16;

    public getListItem = (props: ListRowProps): JSX.Element => {
        const friend: IFRFriend = this.props.friends[props.index];
        const checked: boolean = this.props.listOfCheckedFriends.has(friend.ubiId);

        return (
            <FRFriendListItem
                key={friend.ubiId}
                env={this.props.env}
                friend={friend}
                checked={checked}
                style={props.style}
                onCheck={this.props.onCheck}
                shouldInheritStyles={this.props.shouldInheritStyles}
            />
        );
    };

    /** List also has to receive extra props to trigger nested render function, because it is pure by default  */
    public getList = (props: Size): JSX.Element => {
        return (
            <List
                friends={this.props.friends}
                listOfCheckedFriends={this.props.listOfCheckedFriends}
                width={props.width}
                height={this.CONTAINER_HEIGHT}
                rowCount={this.props.friends.length}
                rowHeight={this.ROW_HEIGHT}
                rowRenderer={this.getListItem}
            />
        );
    };

    public render(): JSX.Element {
        const { shouldInheritStyles, friends, listOfCheckedFriends } = this.props;
        return (
            <div className={getModeClass('sitegen-fr-friend-list-virtualized', shouldInheritStyles)}>
                {/* AutoSizer has to receive extra props to trigger nested render function, because it is pure by default */}
                <AutoSizer friends={friends} listOfCheckedFriends={listOfCheckedFriends}>
                    {this.getList}
                </AutoSizer>
            </div>
        );
    }
}

export interface IFRFriendListVirtualizedProps {
    readonly env: string;
    readonly friends: IFRFriend[];
    readonly listOfCheckedFriends: Set<string>;
    readonly onCheck: (ubiId: string) => void;
    readonly shouldInheritStyles: boolean;
}
